import { render, staticRenderFns } from "./image_diff_viewer_with_discussions.vue?vue&type=template&id=70524476&vue3"
import script from "./image_diff_viewer_with_discussions.vue?vue&type=script&lang=js&vue3"
export * from "./image_diff_viewer_with_discussions.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports